import { defineMessages } from 'react-intl';

// This contains all the translatable interface messages.
const messages = defineMessages({
  cardTitle: {
    id: 'kZ1vMW',
    defaultMessage: 'IBM Cloud Data Centers',
  },
  cardDescription: {
    id: 'ns7uSN',
    defaultMessage: `Explore IBM’s global data network with this interactive map`,
  },
  dataCenter: {
    id: '3i7Hau',
    defaultMessage: 'Data Center',
  },
  federalDataCenter: {
    id: 'yHztb1',
    defaultMessage: 'Federal Data Center',
  },
  multiZone: {
    id: 'V5MN6t',
    defaultMessage: 'Multi-Zone Region',
  },
  networkPoP: {
    id: 'EpJRRQ',
    defaultMessage: 'Network PoP',
  },
});

export default messages;
